export function captionText(image: any, gastro: any): string {
  let uploaderText: string[] = ['Bild hochgeladen von:'];

  if (image.userUrl) {
    if (gastro.getOwner() && gastro.getOwner().id === image.userId) {
      uploaderText = uploaderText.concat(['Inhaber']);
    } else {
      uploaderText = uploaderText.concat([`<a href="${image.userUrl}">${image.userName}</a>`]);
    }
  } else {
    uploaderText = uploaderText.concat(['Gaumenfreund']);
  }

  if (image.created) {
    uploaderText = uploaderText.concat(['am ' + new Date(image.created).toLocaleDateString('de-DE')]);
  }

  if (image.sourceDetail) {
    uploaderText = uploaderText.concat(['über ' + image.sourceDetail]);
  }

  return uploaderText.join(' ');
}